import { execute_generator } from './index'

const root_url = process.env.VUE_APP_API_INSTALL_URL
const root_path = '/installer'

export const get_latest_installation_for_device = id => execute_generator(
    'GET', { service: root_url, resource:`${root_path}/installation/latest_for_device/${id}` }
)

export const installation_request = (method, body) => execute_generator(
    method,
    { service: root_url, resource:`${root_path}/installation/self` },
    body ? body : null
)
